import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { EditableProperty } from './EditableProperty';

export const EditableShareProperty = ({
  entity,
  handleChange,
  patchField,
  placeholder,
  editFormatter,
  labelFormatter,
  ...rest
}) => (
  <EditableProperty
    dto={entity}
    changeHandler={handleChange}
    patchField={patchField}
    placeholder={placeholder}
    targetUrl={`${process.env.REACT_APP_SHARE_SERVICE_URL}/shares/${entity.id}`}
    editFormatter={editFormatter}
    labelFormatter={labelFormatter}
    {...rest}
  />
);

EditableShareProperty.propTypes = {
  patchField: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  editFormatter: PropTypes.oneOfType([PropTypes.node, PropTypes.object, PropTypes.func]).isRequired,
  labelFormatter: PropTypes.oneOfType([PropTypes.node, PropTypes.object, PropTypes.func]).isRequired,
};
